// removed by extract-text-webpack-plugin
module.exports = {"placeholder":"MetaEdit-module__placeholder___12C2l","wrapper":"MetaEdit-module__wrapper___1l3RB","editor":"MetaEdit-module__editor___1xtNs","controls":"MetaEdit-module__controls___1Wf3F","info":"MetaEdit-module__info___3CB0d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MetaEditForm/MetaEdit.module.sass
// module id = 1072
// module chunks = 0